// Must be first: configures shared env + initializes Firebase before any
// service module is invoked during render.
import './config/firebaseInit';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initToolbar } from '@21st-extension/toolbar';
import { App } from './App';
import './styles/index.css';
import { initAdaptiveTestHelper } from './utils/adaptiveTestHelper';

// Dev-only: expose adaptive test helper on window.adaptiveTest
initAdaptiveTestHelper();

// Dev-only: initialize 21st.dev toolbar for UI component browsing
if (import.meta.env.DEV) {
  initToolbar({ plugins: [] });
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
